import { useTranslation } from "react-i18next";
import styles from "./menuLink.module.css";

const ClassLink = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.classLink}>
      <h4 style={{ margin: "0", fontWeight: "800" }}>{t("nav.class7")}</h4>
      <div className={styles.spacer} />
    </div>
  );
};

export default ClassLink;
